import React, { useState, useContext } from 'react';
import { dispatch, useDispatch } from '../../store/index.js';
import { ChangePage } from '../../store/reducers/menu.js';
import { useSelector } from '../../store/index.js';
import { useEffect } from 'react';
import loading from "../../utils/Loading.js";
import { Logout, Login } from '../../store/reducers/auth.js';
import { BASE_URL } from '../../config.js';
import useApi from "../../hooks/useApi.js";
import { useParams } from "react-router-dom";
import { CloseIcon, LeftIcon, RightIcon } from '../../icons/index.js';

function WingoHelpModal() {
    return (
        <div className="modal-overlay fixed inset-0 flex items-center justify-center text-white z-50" style={{ backgroundColor: "rgba(22,22,22,0.8)" }}>
            <div className="fixed inset-0 flex items-center justify-center">
                <div className="flex w-full flex-row justify-center items-center px-4">
                    <div style={{maxWidth: "560px", maxHeight: '666px', margin: '0 auto'}} className="w-full p-4 sm:p-6 md:p-8 bg-opacity-90 rounded-lg shadow-bottom_2 bg-primary  flex justify-start flex-col items-center">                    
                        <div className="text-white font-plus font-bold text-18 leading-22 flex flex-row w-full justify-end items-end" onClick={() => dispatch(ChangePage(""))}><CloseIcon/></div>  
                        <div className="flex flex-col justify-start items-center w-full h-full overflow-y-scroll">
                            <span className='text-yellow-300 text-[20px] font-bold'>Rule of Guess</span>
                            <div className='flex flex-col justify-start items-start gap-2 h-full '>
                                <span className='text-white text-[14px] md:text-[18px] font-plus font-medium'>
                                    - 1 minutes 1 issue, 50 seconds to order, 10 seconds to show the lottery result. It opens all day. The total number of trade is 1440 issues
                                </span>
                                <span className='text-white text-[14px] md:text-[18px] font-plus font-medium'>
                                    - 3 minutes 1 issue, 2 minutes and 30 seconds to order, 30 seconds to show the lottery result. It opens all day. The total number of trade is 480 issues
                                </span>
                                <span className='text-white text-[14px] md:text-[18px] font-plus font-medium'>
                                    - 5 minutes 1 issue, 4 minutes and 30 seconds to order, 30 seconds to show the lottery result. It opens all day. The total number of trade is 288 issues
                                </span>
                                <span className='text-white text-[14px] md:text-[18px] font-plus font-medium'>
                                    - 10 minutes 1 issue, 9 minutes and 30 seconds to order, 30 seconds to show the lottery result. It opens all day. The total number of trade is 144 issues
                                </span>
                                <span className='text-white text-[14px] md:text-[18px] font-plus font-medium'>
                                    - If you spend 100 to trade, after deducting 2 service fee, your contract amount is 98: 
                                </span>
                                <span className='text-darkGreen-150 text-[14px] md:text-[18px] font-plus font-bold'>
                                    - 1. JOIN GREEN:
                                </span>
                                <span className='text-white text-[14px] md:text-[18px] font-plus font-medium pl-4'>
                                    If the result shows 1,3,7,9, you will get (98*2) 196
                                </span>
                                <span className='text-white text-[14px] md:text-[18px] font-plus font-medium pl-4'>
                                    If the result shows 5, you will get (98*1.5) 147
                                </span>
                                <span className='text-red-600 text-[14px] md:text-[18px] font-plus font-bold'>
                                    - 2. JOIN RED:
                                </span>
                                <span className='text-white text-[14px] md:text-[18px] font-plus font-medium pl-4'>
                                    If the result shows 2,4,6,8, you will get (98*2) 196
                                </span>
                                <span className='text-white text-[14px] md:text-[18px] font-plus font-medium pl-4'>
                                     If the result shows 0, you will get (98*1.5) 147
                                </span>
                                <span className='text-purple-600 text-[14px] md:text-[18px] font-plus font-bold'>
                                    - 3. JOIN VIOLET:
                                </span>
                                <span className='text-white text-[14px] md:text-[18px] font-plus font-medium pl-4'>
                                    If the result shows 0 or 5, you will get (98*4.5) 441
                                </span>
                                <span className='text-yellow-300 text-[14px] md:text-[18px] font-plus font-bold'>
                                    - 4. SELECT NUMBER:
                                </span>
                                <span className='pl-4 text-white text-[14px] md:text-[18px] font-plus font-medium'>
                                    If the result is the same as the number you selected, you will get(98*9)882
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WingoHelpModal;